/**
 * @module {function(Element,string,function,bool} util/event/capture
 * @parent utils.modules
 *
 * Returns a function that can be called to bind capturing event listeners.
 * When called, this function returns another function that in turn can be
 * used to unbind the passed in listener.
 */
define('util/event/capture',[ "util/detect/passive-listeners" ], function( hasPassives ) {

	"use strict";

	function capture( element, event, callback, passive ) {
		var
			options = hasPassives ? { capture : true, passive : passive !== false } : true,
			events  = String( event ).match( /\S+/g ),
			n       = events.length;

		while ( --n !== -1 ) {
			element.addEventListener( events[ n ], callback, options );
		}

		return function() {
			if ( events === null ) return;

			var n = events.length;

			while ( --n !== -1 ) {
				element.removeEventListener( events[ n ], callback, options );
			}

			// Prevent potential memory leaks by releasing references
			events
				= callback
				= options
				= null;
		};
	}

	capture.supported = ( "addEventListener" in window );

	return capture;
});
